const translations = {
  "en": {
    "What you own, against this ranking": "What you own, against this ranking"
  },
  "zh-tw": {
    "What you own, against this ranking": "對照你的持倉與這份榜單"
  }
};

export default translations;
